<template>
  <div id="map-wrapper">
    <div id="map"/>
    <div v-if="!$vuetify.breakpoint.smAndDown" id="button-wrapper">
      <MapButton style="z-index: 2" v-on:openUploadDialog="uploadDialog = true"/>

    </div>
    <div id="loading-wrapper">
        <v-progress-circular
            v-show="layerLoading"
            indeterminate
            color="accent"
        />
    </div>
    <UploadForm v-on:closeDialog="uploadDialog = false" :open-dialog="uploadDialog"/>
  </div>
</template>

<script>
    import LeafletServices from "@/services/leaflet.service";
    import MapButton from "@/components/home/MapButton";
    import UploadForm from "@/components/home/UploadForm";
    import { mapState } from "vuex"


    export default {
        name: "Map",
        components: {
            MapButton,
            UploadForm
        },
        data() {
            return {
                uploadDialog: null,
            }
        },
        mounted: function () {
            LeafletServices.initMap("map")
        },
        computed: {
            ...mapState("map", ["layerLoading"])
        }
    }
</script>

<style scoped>
  #map-wrapper {
    width: 100%;
    height: 100%;
    position: relative;
  }

  #map {
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  #button-wrapper {
    position: absolute;
    bottom: 25px;
    right: 10px;
  }

  #loading-wrapper {
    z-index: 2;
    position: absolute;
    bottom: 15px;
    left: 15px;
  }
</style>